
let baseUrl = "http://sports.hneav.com/teacher/api/";

const isHttps = window.location.href.includes("https");

if (isHttps) {
  baseUrl = "https://sports.hneav.com/teacher/api/";
}

module.exports = { baseUrl };